module.exports = __webpack_public_path__ + "img/1124012548.cd2803e5.png";